<template>
	<div class="g-page flex">
		<div style="position: fixed; top: -100px;">
			<input type="text" name="username">
			<input type="password" name="password">
		</div>

		<div class="g-aside flex-column" :fold="asideFoldState">
			<div class="logo flex-center">
				<div class="logo-image">
					<img :src="require('@/assets/image/icon.png')" alt="">
				</div>
				<div class="logo-text">
					<h5>机老大管家</h5>
					<p>回收生意专业ERP</p>
				</div>
			</div>
			<c-scroll class="menu flex-grow" bar-color="rgba(255,255,255,.5)">
				<dl v-for="(menu, i) in navList" :key="i" :ref="`menu-${i}`" class="item" :class="{'z-alive': aliveMenu == menu.menu_unique_key}" @mouseenter="menuMouseInHandle(menu, i)">
					<dt class="flex-center-cross" @click="navHandle(menu, menu)">
						<i class="icon tf" :class="`tf-nav-${menu.menu_unique_key}`"></i>
						<p class="flex-grow">{{menu.menu_name}}</p>
						<i v-if="menu.child_menu_list" class="angle tf-angle-right"></i>
					</dt>
					<dd v-if="menu.child_menu_list" :style="{'height': aliveMenu == menu.menu_unique_key && !asideFoldState ? `${menu.child_menu_list.length * 36 + 20}px` : 0}">
						<div :class="{'sub-menu': subMenuState}" :style="subMenuState ? subMenuStyle[menu.menu_unique_key] : ''">
							<c-scroll bar-color="rgba(255,255,255,.5)">
								<ul>
									<li v-for="(item, j) in menu.child_menu_list" :key="j" class="flex-center-cross" :class="{'z-alive': alivePage == item.menu_unique_key}" :parent="item.is_parent" :child="item.is_child" @click="item.is_parent ? '' : navHandle(item, menu)">
										<p>{{item.menu_name}}</p>
									</li>
								</ul>
							</c-scroll>
						</div>
					</dd>
				</dl>
			</c-scroll>
			<div class="bottom flex-end-center">
				<a class="flex-center" @click="asideFoldState = !asideFoldState"><i class="tf">&#xe6f9;</i></a>
			</div>
		</div>

		<div class="flex-grow flex-column">
			<div class="g-head flex">
				<div class="flex-grow flex-between-center">
					<div class="head-crumb flex-center">
						<template v-for="(item, i) in crumbList">
							<span v-if="i > 0"><i class="tf">&#xeb08;</i></span>
							<p :key="i">{{item}}</p>
						</template>
					</div>
						
					<div class="flex">
						<template v-if="quickList.length">
							<div class="head-button">
								<div class="head-button-main flex-center">
									<img class="icon" src="@/assets/image/menu.png" alt="">
									<span>常用功能</span>
								</div>
								<div class="head-button-quick">
									<ul class="flex-wrap">
										<li v-for="(item, i) in quickList" :key="i" class="flex-center" @click="navigateTo({name: item.route})">{{item.name}}</li>
									</ul>
								</div>
							</div>
							<div class="head-button-line"></div>
						</template>
						<div class="head-button">
							<div class="head-button-main flex-center" @click="globalDialog('produceUniqueCodeDetail')">
								<i class="icon tf">&#xe626;</i>
								<span>背贴码跟踪</span>
							</div>
						</div>
						<div class="head-button">
							<div class="head-button-main flex-center">
								<i class="icon tf-phone"></i>
								<span>移动端入口</span>
							</div>
							<div v-if="systemConfig" class="head-button-service flex-column">
								<div class="mobile flex-column flex-center">
									<img class="qrcode" :src="systemConfig.platform_mini_program_qrcode_url" alt="">
									<p>微信扫一扫<span>进入移动端</span></p>
								</div>
							</div>
						</div>
						<div v-if="normList.length" class="head-button">
							<div class="head-button-main flex-center">
								<i class="icon tf">&#xe64f;</i>
								<span>规则规范</span>
							</div>
							<ul class="head-button-service" style="right: -20px; left: auto;">
								<li v-for="(item, i) in normList" :key="i" @click.stop="globalDialog('articleDetail', {props: {article_type: 3, id: item.id}})">{{item.title}}</li>
							</ul>
						</div>
						<div class="head-button">
							<div class="head-button-main flex-center">
								<i class="icon tf-doc"></i>
								<span>帮助与咨询</span>
							</div>
							<ul class="head-button-service">
								<li @click.stop="$refs.businessService.open()">官方客服</li>
							</ul>
						</div>
						<div class="user-info flex-center">
							<div class="icon flex-center">
								<img src="@/assets/image/head_icon.jpg" alt="">
							</div>
							<div class="info">
								<p class="name flex-start-center">{{userInfo.user_realname}}<span class="tag">{{userInfo.is_manage == 1 ? '主账号' : '子账号'}}</span></p>
								<p class="saas"><span>{{saasInfo.saas_name}}</span></p>
							</div>
							<i class="arrow tf-tri-down"></i>
							
							<div class="menu">
								<div class="item" @click="$refs.resetPswForm.clear(); $refs.resetPsw.open()">{{userInfo.is_user_pwd ? '修改密码' : '设置密码'}}</div>
								<div class="item" @click="logout">安全退出</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="notice" class="g-notice flex-center">
				<i class="tf">&#xe621;</i>
				<div class="content flex-grow flex">
					<div class="flex" :class="{'content-scroll': noticeScroll}" :style="{'animation-duration': `${noticeScroll / 25}s`}">
						<p ref="notice">{{notice}}</p>
						<p v-if="noticeScroll">{{notice}}</p>
					</div>
				</div>
			</div>
			
			<div class="g-content flex-grow">
				<router-view v-if="initialized" ref="routerView"></router-view>
			</div>
		</div>
		
		<c-dialog ref="resetPsw" :title="userInfo.is_user_pwd == 1 ? '修改登录密码' : '设置登录密码'" width="440" @resolve="resetPassword">
			<c-form ref="resetPswForm">
				<c-form-item label="旧密码" v-if="userInfo.is_user_pwd == 1" required>
					<c-input type="password" name="old_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="新密码" required>
					<c-input type="password" name="user_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="确认密码" required>
					<c-input type="password" name="confirm_pwd" visible></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog v-if="systemConfig" ref="businessService" width="400" :title="false" :button="false"  mask-close>
			<div class="custom-service flex-column flex-center">
				<i class="tf icon">&#xe61d;</i>
				<h1>机老大管家官方客服</h1>
				<h2>专业二手回收 ERP，收、检、存、销、财，一站式管理系统，一机一码溯源，回收做账两不误;</h2>
				<img :src="systemConfig.platform_service_qrcode_url" alt="">
				<p>微信扫一扫咨询</p>
				<div class="tel flex-center">
					<i class="tf">&#xe679;</i>
					<b>{{systemConfig.platform_service_phone}}</b>
				</div>
			</div>
		</c-dialog>
	</div>
</template>

<script>
	import {cryptoJs} from '@deanwu/vue-component-library'
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		name: 'Sys',

		data() {
			return {
				asideFoldState: !!parseInt(localStorage.getItem('asideFoldState')),
				subMenuState: !!parseInt(localStorage.getItem('asideFoldState')),
				aliveMenu: null,
				alivePage: null,
				subMenuStyle: {},

				crumbList: [],
				templateConfig: false,
				appViewConfig: false,
				activeHeadButton: null,

				pageButtonList: [],
				quickList: [],
				normList: [],

				notice: '',
				noticeScroll: false
			}
		},
		
		computed: {
			...mapState(['saasInfo', 'userInfo', 'navList', 'systemConfig', 'authList']),
			...mapGetters(['initialized']),
			
			headButtonList() {
				if (!this.initialized) return [];
				let arr = [];
				if (this.templateConfig) {
					arr.push({
						name: '模板管理',
						icon: 'tf-template',
						handle: () => {
							this.globalDialog('templateManage', {
								props: this.templateConfig
							})
						}
					});
				}

				if (this.appViewConfig) {
					let list = [];
					['extendView', 'detailView'].forEach(type => {
						if (this.appViewConfig[type]) {
							list = list.concat(
								this.appViewConfig[type].filter(item => !item.disabled || !item.disabled.call(this)).map(item => {
									let name = type == 'detailView' ? `详情-${item.name}` : item.name;
									return {
										name,
										handle: () => {
											this.globalDialog('appViewConfig', {
												props: item,
												data: {
													name,
													baseInfo: item.baseInfo === false ? false : true
												}
											})
										}
									}
								})
							)
						}
					});

					if (list.length && this.appViewConfig.viewId) {
						list.unshift({
							name: '列表卡片',
							handle: () => {
								this.globalDialog('appViewConfig', {
									props: this.appViewConfig,
									data: {
										name: '列表',
										baseInfo: this.appViewConfig.baseInfo === false ? false : true
									}
								})
							}
						});
					}

					arr.push({
						name: '移动端卡片管理',
						icon: 'tf-app-card',
						list: list.length ? list : null,
						handle: list.length ? null : () => {
							this.globalDialog('appViewConfig', {
								props: this.appViewConfig,
								data: {
									name: '列表',
									baseInfo: this.appViewConfig.baseInfo === false ? false : true
								}
							})
						}
					});
				}

				return this.pageButtonList.concat(arr);
			}
		},
		
		watch: {
			$route(val) {
				this.pageButtonList = [];
				this.parseRoute(val);
				if (val.name == '404') {
					this.aliveMenu = this.alivePage = null;
					return;
				};
				this.updateAlivePage();
				this.updateNotice();
			},

			navList() {
				this.parseRoute();
				this.updateAlivePage();
			},

			asideFoldState(val) {
				localStorage.setItem('asideFoldState', val ? 1 : 0);

				if (val) {
					this._asideTimer = setTimeout(() => {
						this.subMenuState = true;
					}, 500);
				} else {
					clearTimeout(this._asideTimer);
					this.subMenuState = false;
				}

				clearTimeout(this._asideFoldEndTimer);
				clearInterval(this._asideFoldTimer);
				this._asideFoldTimer = setInterval(() => {
					if (this.$refs.routerView.$options.name == 'home') {
						this.$refs.routerView.resize();
					}
				}, 10);
				this._asideFoldEndTimer = setTimeout(() => {
					clearInterval(this._asideFoldTimer);
				}, 550);
			}
		},
		
		created() {
			this.$store.dispatch('updateSystemConfig');
		},
		
		mounted() {
			this.parseRoute();
			this.updateAlivePage();
			window.addEventListener('click', () => {
				this.activeHeadButton = null;
			}, true);

			this.updateNotice();
			this.updateQuick();
			this.updateNorm();
			this.$bus.$on('updateQuick', this.updateQuick);
		},

		beforeDestroy() {
			clearTimeout(this._noticeTimer);
		},
		
		methods: {
			menuMouseInHandle(menu, i) {
				if (this.asideFoldState) {
					let rect = this.$refs[`menu-${i}`][0].getBoundingClientRect();
					let height = menu.child_menu_list ? menu.child_menu_list.length * 36 + 20 : 0;
					let topHeight = window.innerHeight - rect.top - 20;
					let maxHeight = window.innerHeight - 40;
					this.$set(this.subMenuStyle, menu.menu_unique_key, {
						'top': (maxHeight < height ? 20 : topHeight < height ? rect.top - (height - topHeight) : rect.top) + 'px',
						'height': Math.min(height, maxHeight) + 'px'
					});
				}
			},

			navHandle(item, menu) {
				if (!item.menu_unique_key) return;
				if (
					item == menu && (!this.asideFoldState || !item.child_menu_list)
					||
					item != menu && this.asideFoldState
				) {
					if (this.aliveMenu == menu.menu_unique_key) {
						this.aliveMenu = '';
					} else {
						this.aliveMenu = menu.menu_unique_key;
					}
				}

				if (item != menu || item.menu_unique_key == 'home') {
					this.alivePage = item.menu_unique_key;
					this.navigateTo({
						name: item.menu_unique_key
					});
				}
			},

			parseRoute(route = this.$route) {
				let crumb = [];
				!function loop(index, list) {
					let item = route.matched[index];
					if (!item) return;
					if (item.meta.title) {
						crumb.push(item.meta.title)
					} else if (list && item.name) {
						let menu = list.find(temp => temp.menu_unique_key == item.name);
						if (menu) {
							crumb.push(menu.menu_name);
							list = menu.child_menu_list;
						}
					}
					loop(++index, list);
				}(0, this.navList);
				this.crumbList = crumb;

				if (route.meta.appView && this.auth(route.meta.appView.auth)) {
					this.appViewConfig = route.meta.appView;
				} else {
					this.appViewConfig = false;
				}

				if (route.meta.templateManage && (this.auth(route.meta.templateManage.print) || this.auth(route.meta.templateManage.export))) {
					this.templateConfig = route.meta.templateManage;
				} else {
					this.templateConfig = false;
				}
			},

			updateAlivePage(route = this.$route) {
				if (route.name == '404') {
					this.navigateTo('/');
					return;
				};

				this.alivePage = route.name;
				if (this.alivePage) {
					let menu = this.navList.find(menu => {
						return menu.child_menu_list ? menu.child_menu_list.find(item => {
							return item.menu_unique_key == this.alivePage;
						}) : menu.menu_unique_key == this.alivePage;
					});
					menu && (this.aliveMenu = menu.menu_unique_key);
				}
			},

			headButtonHandle(item) {
				if (item.list) {
					this.activeHeadButton = item;
				} else {
					this.activeHeadButton = null;
				}
				item.handle && item.handle();
			},
			
			logout() {
				this.$confirm({
					message: '确定要退出登录吗？',
					resolve: () => {
						this.request({
							url: '/sys_user/logout',
							loading: true,
							success: () => {
								this.$store.commit('setSession', '');
								this.navigateTo('/login');
							}
						});
					}
				});
			},
			
			resetPassword(stop) {
				stop();
				this.$refs.resetPswForm.submit({
					url: '/sys_user/update_pwd',
					rule: {
                        old_pwd: [{
                            type: 'empty',
                            message: '请填写旧密码',
                            skip: () => {
                                return this.userInfo.is_user_pwd == 0;
                            }
                        }],
						user_pwd: '请填写新密码',
						confirm_pwd: [{
							type: 'empty',
							message: '请在填写一次新密码'
						}, {
							type: 'function',
							fun: (value, data) => {
								return data.user_pwd == value
							},
							message: '两次输入的新密码不一致'
						}]
					},
					dataFormatter: data => {
						if (this.userInfo.is_user_pwd) {
							data.old_pwd = cryptoJs.MD5(data.old_pwd).toString();
						}
						data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
						delete data.confirm_pwd;
						return data;
					},
					success: () => {
						this.$message({
							type: 'success',
							message: '密码修改成功'
						});
                        //重新获取用户信息
                        this.$store.dispatch('updateLoginInfo');
						this.$refs.resetPsw.close();
					}
				});
			},

			updateNotice() {
				clearTimeout(this._noticeTimer);
				this.request({
					url: '/system/notice',
					success: data => {
						this.notice = data ? data.sub_title : '';
						if (this.notice) {
							this.$nextTick(() => {
								let $notice = this.$refs.notice;
								if (!this._noticeScroll) {
									this._noticeScroll = () => {
										this.noticeScroll = $notice.clientWidth > $notice.parentElement.parentElement.clientWidth ? $notice.clientWidth : 0;
									}
									window.addEventListener('resize', this._noticeScroll);
								}
								this._noticeScroll();
							});
						} else {
							window.removeEventListener('resize', this._noticeScroll);
							delete this._noticeScroll;
						}

						this._noticeTimer = setTimeout(() => {
							this.updateNotice();
						}, 30 * 60 * 1000);
					}
				});
			},

			setHeadButton(data) {
				this.pageButtonList = data.filter(item => this.auth(item.auth)).map(item => {
					return item;
				});
			},

			updateQuick() {
				this.request({
					url: '/workbench/frequent',
					data: {},
					success: data => {
						const options = this.getFrequentRouteOptions();
						const routeMap = options.reduce((map, item) => {
							map[item.route] = item;
							return map;
						}, {});
						const displayList = (data.display_list || []).map(item => routeMap[item.route_name]).filter(Boolean);
						// 后台未配置常用功能时，默认取前八个
						this.quickList = displayList.length ? displayList : options.slice(0, 8);
					}
				});
			},

			updateNorm() {
				this.request({
					url: '/article/published/list',
					data: {
						article_type: 3
					},
					success: data => {
						this.normList = data;
					}
				});
			},

			getFrequentRouteOptions() {
				const authMap = this.authList.reduce((map, item) => {
					map[item.key] = true;
					return map;
				}, {});
				const options = [];
				const collect = menuList => {
					(menuList || []).forEach(menu => {
						if (menu.menu_unique_key && /^m_[A-Za-z0-9_]{1,61}$/.test(menu.menu_unique_key) && authMap[menu.menu_unique_key] && this.auth(menu.menu_unique_key)) {
							options.push({name: menu.menu_name, route: menu.menu_unique_key});
						}
						collect(menu.child_menu_list);
					});
				};
				collect(this.navList);
				return options.filter((item, index) => options.findIndex(option => option.route === item.route) === index);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-page {
		height: 100vh;
		
		.g-aside {
			z-index: 100;
			position: relative;
			width: 200px;
			background: #112C5C;
			transition: width .5s ease;

			&[fold] {
				width: 60px;
			}
			
			.logo {
				position: relative;
				min-height: 90px;

				&-image {
					position: relative;
					height: 44px;
					pointer-events: none;
				
					img {
						max-width: none;
						height: 100%;
					}
				}

				&-text {
					max-width: 100px;
					margin-left: 14px;
					white-space: nowrap;
					transition: all .5s ease;
					pointer-events: none;

					^[-2][fold] ^[-2..-1] {
						max-width: 0;
						margin-left: 0;
					}
				}

				h5 {
					font-size: 18px;
					white-space: nowrap;
					color: #fff;
					opacity: 1;
					transition: opacity .2s ease;

					^[-2][fold] ^[-2..-1] {
						opacity: 0;
					}
				}

				p {
					margin-top: 10px;
					font-size: 12px;
					white-space: nowrap;
					color: #fff;
					opacity: .7;
					transition: opacity .2s ease;

					^[-2][fold] ^[-2..-1] {
						opacity: 0;
					}
				}

				span {
					position: absolute;
					left: 0;
					top: 0;
					border-radius: 0 12px 12px 0;
					padding: 0 9px 0 6px;
					line-height: 24px;
					font-size: 14px;
					font-weight: 500;
					white-space: nowrap;
				}
			}
			
			.menu {
				margin-top: 10px;

				.item {
					width: 200px;
					transition: background .3s ease, width .5s ease;

					&:nth-child(n+2) {
						margin-top: 5px;
					}

					^[-2][fold] ^[-2..-1] {
						width: 60px;

						&:hover {
							.sub-menu {
								display: block;
							}
						}
					}

					^[-2]:not([fold]) ^[-2..-1].z-alive dd {
						background: #0E2651;
					}

					dt {
						height: 46px;
						overflow: hidden;
						color: #fff;
						cursor: pointer;
						transition: all .2s ease;

						^[-3][fold] ^[-3..-1] {
							border-radius: 6px !important;
							padding: 0 13px;
							margin: 0 5px;
							color: #fff;
						}

						^[-3][fold] ^[-2..-2]:hover ^[-1..-1] {
							background: #0078FF;
						}

						^[-3]:not([fold]) ^[-3..-1] {
							border-radius: 6px;
							padding: 0 14px;

							&:hover {
								background: #0078FF;
							}
						}
						
						^[-1].z-alive ^[-1..-1] {
							border-radius: 6px 6px 0 0;
							color: #fff;
							background: #0078FF;

							.angle {
								transform: rotate(90deg);
							}
						}
						
						.icon {
							width: 1em;
							font-size: 16px;
							text-align: center;

							^[-4][fold] ^[-3..-1] {
								min-width: 24px;
								font-size: 18px;
							}
						}

						p {
							margin: 0 12px;
							font-size: 15px;
							font-weight: bold;
							white-space: nowrap;
							opacity: 1;
							pointer-events: none;
							transition: opacity .2s ease;

							^[-4][fold] ^[-3..-1] {
								opacity: 0;
							}
						}

						.angle {
							font-size: 13px;
							opacity: 1;
							pointer-events: none;
							transition: transform .3s ease, opacity .2s ease;

							^[-4][fold] ^[-3..-1] {
								opacity: 0;
							}
						}
					}
					
					dd {
						padding: 0 10px;
						overflow: hidden;
						transition: height .3s ease;
						
						^[-1].z-alive ^[-1..-1] {
							height: auto;
						}

						ul {
							padding: 10px 0;
						}
						
						li {
							&[parent] {
								position: relative;
								height: 36px;
								padding: 0 16px;
								font-size: 14px;
								white-space: nowrap;
								color: #D9E0E9;

								&:before {
									content: '';
									width: 5px;
									height: 2px;
									border-radius: 1px;
									margin-right: 10px;
									background: #eee;
								}
							}
							
							&[child] {
								height: 36px;
								padding-left: 42px;
								font-size: 13px;
								white-space: nowrap;
								color: #D9E0E9;
								cursor: pointer;
								transition: all .3s ease;
								
								&:hover,
								&.z-alive {
									color: #fff;
								}

								&.z-alive {
									background: rgba(255,255,255,.15);
								}
							}

							&:not([child]):not([parent]) {
								position: relative;
								height: 36px;
								padding: 0 14px;
								font-size: 14px;
								white-space: nowrap;
								color: #D9E0E9;
								cursor: pointer;
								transition: all .3s ease;
								
								&:hover,
								&.z-alive {
									color: #fff;
								}

								&.z-alive {
									border-radius: 4px;
									background: rgba(255,255,255,.1);
								}

								&:before {
									content: '';
									width: 5px;
									height: 2px;
									border-radius: 1px;
									margin-right: 10px;
									background: #eee;
									transition: all .2s ease;

									^[-1]:hover^[-1..-1],
									^[-1].z-alive^[-1..-1] {
										width: 12px;
										background: #fff;
									}
								}
							}
						}
					}
				}
			}

			.sub-menu {
				display: none;
				position: fixed;
				left: 60px;
				padding-left: 6px;
				animation: subMenuFadeIn .4s;
				
				@keyframes subMenuFadeIn {
					0% {
						opacity: 0;
						transform: translate(0,10px);
					}

					100% {
						opacity: 1;
						transform: translate(0,0);
					}
				}

				>>> .c-scroll {
					border-radius: 4px;
					background: #0E2651;
				}

				ul {
					box-sizing: border-box;
					width: 180px;
					padding: 10px;

					li {
						margin: 0 5px;

						&.z-alive {
							background: rgba(255,255,255,.1) !important;
						}
					}
				}
			}

			.bottom {
				min-height: 40px;
				border-top: 1px solid rgba(255,255,255,.15);
				padding: 0 10px 0 18px;
				color: #fff;
				transition: padding .2s ease;

				^[-1][fold] ^[-1..-1] {
					padding: 0 15px;
				}

				a {
					width: 30px;
					height: 30px;
					font-size: 16px;
					opacity: .6;

					&:hover {
						opacity: 1;
					}

					^[-2][fold] ^[-2..-1] {
						transform: rotate(180deg);
					}
				}
			}
		}
		
		.g-head {
			z-index 50;
			position: relative;
			height: 50px;
			background: #fff;
			box-shadow: 0 1px 5px 0 rgba(0,0,0,.1);

			.head-crumb {
				gap: 10px;
				padding-left: 20px;
				color: #999;

				p:nth-last-child(1) {
					color: #000;
				}
			}
			
			.head-button {
				position: relative;

				&:nth-child(n+2) {
					margin-left: 20px;
				}

				&-main {
					position: relative;
					height: 50px;
					font-size: 13px;
					color: #444;
					cursor: pointer;

					^[-1]:hover ^[-2..-1],
					^[-1][active] ^[-2..-1] {
						color: var(--color-main);
					}

					.icon {
						font-size: 16px;

						+ span {
							margin-left: 6px;
						}
					}

					img.icon {
						width: 18px;
						height: 18px;
					}

					.error {
						position: absolute;
						left: 8px;
						top: 12px;
						font-size: 12px;
						color: #f00;
					}

					.vip {
						height: 14px;
						margin-left: 4px;
					}
				}

				&-list {
					display: none;
					z-index: 90;
					position: absolute;
					left: 0;
					top: 100%;
					border: 1px solid #eee;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);

					^[-1][active] ^[-1..-2] {
						display: block;
					}

					li {
						height: 36px;
						padding: 0 16px;
						white-space: nowrap;
						font-size: 13px;
						color: #444;
						cursor: pointer;

						&:nth-child(n+2) {
							border-top: 1px solid #eee;
						}

						&:hover {
							color: var(--color-main);
						}
					}
				}

				&-quick {
					display: none;
					z-index: 90;
					position: absolute;
					left: -20px;
					top: 100%;
					padding-top: 10px;

					&:before {
						content: '';
						position: absolute;
						left: 50px;
						top: 4px;
						border-bottom: 6px solid #fff;
						border-left: 8px solid rgba(0,0,0,0);
						border-right: 8px solid rgba(0,0,0,0);
					}

					^[-1]:hover ^[-1..-2] {
						display: block;
					}

					ul {
						column-gap: 14px;
						row-gap: 10px;
						width: 460px;
						border-radius: 6px;
						padding: 16px 20px;
						background: #fff;
						box-shadow: 0 -3px 5px 2px rgba(0,0,0,.05);

						li {
							box-sizing: border-box;
							width: calc((100% - 42px) / 4);
							height: 36px;
							border: 1px solid #eee;
							border-radius: 4px;
							font-size: 13px;
							color: #333;
							background: #F9F9F9;
							cursor: pointer;

							&:hover {
								border-color: var(--color-main);
								color: var(--color-main);
								background: #fff;
							}
						}
					}
				}

				&-service {
					display: none;
					z-index: 90;
					position: absolute;
					left: -20px;
					top: 100%;
					box-sizing: border-box;
					min-width: 160px;
					padding: 12px 0;
					border: 1px solid #eee;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);

					^[-1]:hover ^[-1..-2] {
						display: block;
					}

					li {
						position: relative;
						padding: 0 20px;
						white-space: nowrap;
						line-height: 36px;
						font-size: 13px;
						color: #444;
						cursor: pointer;

						&:hover {
							color: var(--color-main);
						}
					}

					.mobile {
						box-sizing: border-box;
						padding: 0;
						line-height: initial;
						font-size: 0;
						background: #fff;

						.qrcode {
							width: 130px;
							max-width: none;
							height: 130px;
						}

						p {
							padding-top: 5px;
							line-height: 22px;
							font-size: 12px;
							text-align: center;
							color: #666;

							span {
								color: #f55;
							}
						}
					}
				}

				&-line {
					width: 1px;
					height: 50px;
					margin: 0 15px;
					background: linear-gradient(0deg, #FFFFFF, #DDDDDD, #FFFFFF);

					+ .head-button {
						margin-left: 0;
					}
				}
			}
			
			.user-info {
				gap: 8px;
				z-index: 100;
				position: relative;
				height: 50px;
				padding: 0 20px;
				cursor: pointer;
				transition: all .3s ease;
				
				&:hover {
					.menu {
						display: block;
					}
				}
				
				.icon {
					width: 36px;
					height: 36px;
					border-radius: 100%;
					overflow: hidden;
				}

				.name {
					font-size: 13px;
				}

				.tag {
					border-radius: 3px;
					margin-left: 6px;
					padding: 3px 4px;
					font-size: 12px;
					color: var(--color-main);
					background: #EEF2FF;
				}

				.saas {
					margin-top: 4px;
					font-size: 12px;
					color: #999;
				}
				
				.arrow {
					font-size: 11px;
					color: #999;

					^[-1]:hover ^[-1..-1] {
						color: var(--color-main);
					}
				}
				
				.menu {
					display: none;
					z-index: 12;
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					border: 1px solid #eee;
					padding: 8px 0;
					color: #000;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);
					
					.item {
						position: relative;
						padding: 0 10px 0 16px;
						line-height: 36px;
						font-size: 13px;
						color: #333;
						
						&:hover {
							color: var(--color-main);
						}
						
						.dot {
							position: absolute;
							right: 20px;
							top: 50%;
							width: 6px;
							height: 6px;
							border-radius: 100%;
							background: #f00;
							transform: translate(0, -50%);
						}
					}
				}
			}
		}

		.g-notice {
			gap: 10px;
			height: 30px;
			padding: 0 12px;
			line-height: 20px;
			font-size: 12px;
			color: #f55;
			background: #FFFADB;

			.tf {
				font-size: 16px;
			}

			.content {
				overflow: hidden;
				white-space: nowrap;

				&-scroll {
					transform: translate(0, 0);
					animation-name: loopScroll;
					animation-timing-function: linear;
					animation-iteration-count: infinite;

					@keyframes loopScroll {
						0% {
							transform: translate(0, 0);
						}
						100% {
							transform: translate(-50%, 0);
						}
					}
				}

				p:nth-child(2),
				p:nth-last-child(2) {
					margin-right: 50px;
				}
			}
		}
		
		.g-content {
			overflow: auto;
			background: #F5F4F7;
		}
	}

	.service-code {
		padding: 30px 0 20px;

		.icon {
			font-size: 48px;
			color: #00BB00;
		}

		h1 {
			margin-top: 20px;
			font-size: 16px;
		}

		img {
			width: 130px;
			height: 130px;
			border: 5px solid #D9F2EC;
			border-radius: 6px;
			margin: 18px 0 9px;
		}

		p {
			font-size: 13px;
			color: #999;
		}
	}

	.custom-service {
		padding: 30px 0 18px;

		.icon {
			font-size: 48px;
			color: #00BB00;
		}

		h1 {
			margin-top: 12px;
			font-size: 22px;
		}

		h2 {
			width: 310px;
			margin-top: 10px;
			line-height: 20px;
			font-size: 13px;
			font-weight: normal;
			text-align: center;
			color: #666;
		}

		img {
			width: 130px;
			height: 130px;
			border: 5px solid #D9F2EC;
			border-radius: 6px;
			margin: 20px 0 9px;
		}

		p {
			font-size: 13px;
			color: #999;
		}

		.tel {
			gap: 10px;
			width: 340px;
			height: 50px;
			border-radius: 6px;
			margin-top: 16px;
			font-size: 22px;
			color: #fff;
			background: var(--color-main);
		}
	}
</style>